import type { FormApi } from 'final-form';

/** Функция пакетного обновления значения полей sme-form */
export const updateFormFields = <T = any>(
    { change }: FormApi<T>,
    fields: Partial<Record<string, unknown>>
) => {
    Object.entries(fields).forEach(([key, val]) => change(key, val));
};
